import { useCallback } from 'react';
import PropTypes from 'prop-types';
import UITextInput from 'UIComponents/input/UITextInput';
import styled from 'styled-components';
import get from 'transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledTextInput = styled(UITextInput).withConfig({
  displayName: "SubjectInput__StyledTextInput",
  componentId: "sc-1ag7xt6-0"
})(["&&&{border:none;background:transparent;font-size:14px;font-weight:normal;padding-top:8px;padding-left:0;&:hover,&:focus{box-shadow:none;border:none;}}"]);
const SubjectInput = ({
  onChange,
  onFocus,
  value = '',
  settings = {
    editable: true,
    required: false
  }
}) => {
  const handleChange = useCallback(({
    target: {
      value: nextValue
    }
  }) => {
    onChange(nextValue);
  }, [onChange]);
  return /*#__PURE__*/_jsx(StyledTextInput, {
    disabled: !get('editable', settings),
    onChange: handleChange,
    onFocus: onFocus,
    value: value,
    type: "text"
  });
};
SubjectInput.displayName = 'SubjectInput';
SubjectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  settings: PropTypes.object,
  value: PropTypes.string
};
export default SubjectInput;